var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["contentful/ugc-close.j2"] = require( "contentful/ugc-close.j2" );
dependencies["contentful/ugc-expanded-tile.j2"] = require( "contentful/ugc-expanded-tile.j2" );
dependencies["contentful/ugc-tray-carousel.j2"] = require( "contentful/ugc-tray-carousel.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/contentful/ugc-tray.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "core/templates/contentful/ugc-tray.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("imageUrl")) {
var t_4 = t_1.imageUrl;
} else {
cb(new Error("cannot import 'imageUrl'")); return;
}
context.setVariable("imageUrl", t_4);
output += "\n\n<div class=\"c-ugc-tray dom-ugc-tray-carousel\" data-index=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "multipleIndex"), env.opts.autoescape);
output += "\">\n\n    ";
env.getTemplate("contentful/ugc-close.j2", false, "core/templates/contentful/ugc-tray.j2", null, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
output += t_6
output += "\n\n    <div class=\"o-row\">\n\n        <div class=\"g-ugc-tray__expanded-tile c-ugc-tray__expanded-tile\">\n\n            ";
output += "\n            ";
env.getTemplate("contentful/ugc-expanded-tile.j2", false, "core/templates/contentful/ugc-tray.j2", null, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
t_9.render(context.getVariables(), frame, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
output += t_10
output += "\n\n        </div>\n\n        <div class=\"g-ugc-tray__carousel c-ugc-tray__related-products\">\n\n            ";
env.getTemplate("contentful/ugc-tray-carousel.j2", false, "core/templates/contentful/ugc-tray.j2", null, function(t_15,t_13) {
if(t_15) { cb(t_15); return; }
t_13.render(context.getVariables(), frame, function(t_16,t_14) {
if(t_16) { cb(t_16); return; }
output += t_14
output += "\n\n        </div>\n\n    </div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/contentful/ugc-tray.j2"] , dependencies)